import { render } from "./importModal.vue?vue&type=template&id=3d5fa580&ts=true"
import script from "./importModal.vue?vue&type=script&lang=ts"
export * from "./importModal.vue?vue&type=script&lang=ts"

import "./importModal.vue?vue&type=style&index=0&id=3d5fa580&lang=scss"

import exportComponent from "D:\\project\\unnati\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__